import React from 'react';
import { withRouter } from 'react-router-dom'
import Navbar from "../Components/Navbar";
import "./Register.css";
import Footer from "../Components/Footer";
import { API_MOSA_URL, ACCESS_TOKEN_NAME } from '../constants/apiContants';
import Swal from 'sweetalert2'
import axios from 'axios';
import LoadingOverlay from 'react-loading-overlay';

class Validate extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            otp: '',
            sessionid:this.props.location.state.sessioid,
            errors:{}
        };
        console.log(this.props.location.state.sessioid);
        this.sendDetailsToServer = this.sendDetailsToServer.bind(this)

    }
    myChangeHandler = (event) => {
        this.setState({ [event.target.name]: event.target.value });
    }
    mySubmitHandler = (event) => {
        let errors = {};

        event.preventDefault();
        //this.props.history.push('/validate');
        console.log(JSON.stringify(this.state));
        if (!this.state.otp) {
            ///formIsValid = false;
            errors["otp"] = "OTP Cannot be empty";
        }
         else{
            console.log("You are submitting " + JSON.stringify(this.state));
            //this.redirectToValidate();
             this.sendDetailsToServer(this.state);
        }

        
        this.setState({errors:errors});

    }

    sendDetailsToServer = (data) => {
        this.setState({ isActive: true });

        const devicedetails = {
            "imei": "862188038288320",
            "deviceOSVersion": "6.0.1",
            "uuid": "862188038288320",
            "deviceModel": "NOKIA 100",
            "deviceManufacturer": "Xiaomi",
            "serviceProvider": "airtel",
            "deviceOS": "ANDROID",
            "ipAddress": "192.168.43.210"
        }
        const headers = {
            "RequestMode": "0",
            "UserID": "3",
            "BearerKey": "Mobile",
            "ServiceId": "SERV!",
            "SessionId": "1236545",
            "Locale": "E/A",
            "DeviceDet": devicedetails

        }
        // const payload = {
        //     "username": this.state.username,
        //     "password": this.state.password,
        //     ReqHead: headers
        // }
        const payload = {
            "session_id": data.sessionid,
            "otp": data.otp,
            ReqHead: headers
        }
        //localStorage.setItem(ACCESS_TOKEN_NAME,'response.data.token');
        let self = this; //  declared var 

        // redirectToHome();
        const mosa = { "mast": payload }
        console.log('calling api ...' + JSON.stringify(payload));
        axios.post(API_MOSA_URL + '/User/ConfirmOTPRegistation', payload)
            .then(function (response) {
                console.log(JSON.stringify(response));
                self.setState({ isActive: false });


                if (response.status === 200) {
                    //this.props.history.push('/validate');
                    if (response.data[0].StatusCode == "0") {
                       //self.redirectToValidate();
                       self.props.history.push('/setpassword',{sessioid:response.data[1].session_id});
                       //self.props.history.push('/validate',{sessioid:response.data[1].session_id});
                    }
                    else {
                        Swal.fire({
                            title: 'Error!',
                            text: response.data[0].Message,
                            icon: 'error',
                            confirmButtonText: 'Ok'
                        })
                    }

                } else {
                    //  props.showError("Some error ocurred");
                }
            })
            .catch(function (error) {
                console.log(error);
            });


    }

    redirectToSetpwd = () => {
        this.props.history.push('/setpassword');
        //   props.updateTitle('Register');
    }
    render() {
        return (
            <LoadingOverlay
            active={this.state.isActive}
            spinner
            text='Loading ...'>
        
            <div id="LoginForm">
            <Navbar/>
            <div className="container">
            <h1 className="form-heading"></h1>
            <div className="login-form">
                <div className="main-div">
                    <div className="panel">
                        <h2>Step 2</h2>
                        <p>Please validate OTP to complete registration</p>
                    </div>
                    <form id="Login" name="my-form"  onSubmit={this.mySubmitHandler}>
                        
                        <div className="form-group">
                                <input type="text" 
                                id="email_address" 
                                onChange={this.myChangeHandler} 
                                placeholder="Enter OTP"
                                 className="form-control" 
                                 name="otp" />
                                <span style={{color: "red"}}>{this.state.errors["otp"]}</span>                        </div>
                        
                                <div className="row">
                                    <div className="col col-5 btn btn-info">
                                            <div className="" role="button">Back</div>
                                    </div>
                                    <div className="col col-2"/>
                                            <button type="submit" className="col col-5  btn  btn-success">Next</button>
                                   
                                </div>

                    </form>
                    <div id="register-link" className="text-center" style={{  marginTop: '20px'
                            }}>
                            <a href="#" >Resend OTP</a>
                    </div>
                </div>
            </div>
        </div>

      <Footer/>
      </div>
      </LoadingOverlay>
       )
    }
}
export default withRouter(Validate);
